import CardSkeleton from "@/components/Skeleton/CardSkeleton";
import SectionHeadingSkeleton from "@/components/Skeleton/SectionHeadingSkeleton";

export default function JobOutcomeSkeleton() {
  return (
    <div data-testid="job-outcome-skeleton">
      <SectionHeadingSkeleton />
      <div className="flex flex-col md:flex-row gap-x-10">
        <div className="basis-1/3 pb-10">
          <CardSkeleton rows={8} width={100} />
        </div>
        <div className="basis-2/3">
          <CardSkeleton rows={8} width={100} />
        </div>
      </div>
    </div>
  );
}
